<template>
  <div class="Perfect">
    <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        完善个人信息
      </p>
    </header>
    <section>
      <div class="per-msg">
        <p class="title">
          请真实填写您的个人信息
        </p>
        <div class="name">
          <p>姓名</p>
          <p>
            <input type="text" placeholder="请输入姓名" v-model="realname">
          </p>
        </div>
        <div class="sex">
          <p>性别</p>
          <p>
            <input type="text" placeholder="请选择" readonly @click="sexSelect" v-model="sex">
          </p>
        </div>
        <div class="phone">
          <p>手机号</p>
          <p>
            <input type="text" placeholder="请选择" readonly @click="sexSelect" v-model="sex">
          </p>
        </div>
        <div class="code">
          <p><input type="number"></p>
          <p>
            <button>获取验证码</button>
          </p>
        </div>
        <div class="address">
          <p>收货地址</p>
          <p>
            <input type="text" placeholder="请选择" readonly v-model="userlist.address" @click="showAddressChuang" style="width: 4.5rem">
          </p>
        </div>
        <div class="detail-address">
          <p>详细地址</p>
          <p>
            <input type="text" placeholder="请输入" style="width: 4rem" v-model="addressMsg">
          </p>
        </div>
        <div class="work">
          <p>行业背景</p>
          <p>
            <input type="text" placeholder="请输入" v-model="job">
          </p>
        </div>
        <div class="id-card">
          <p>身份证号码</p>
          <p>
            <input type="text" placeholder="请输入" v-model="card_no">
          </p>
        </div>
        <!-- <p class="title-tow">
          银行卡信息
        </p>
        <div class="id-card">
          <p>持卡人姓名</p>
          <p>
            <input type="text" placeholder="请输入">
          </p>
        </div>
        <div class="id-card">
          <p>开户行信息</p>
          <p>
            <input type="text" placeholder="请输入" style="width: 4rem">
          </p>
        </div>
        <div class="id-card">
          <p>卡号</p>
          <p>
            <input type="text" placeholder="请输入" style="width: 4rem">
          </p>
        </div> -->
      </div>
      <!-- 提交按钮 -->
      <p class="sub-btn" @click="submitBtn">
        提交
      </p>
    </section>
    <!-- 性别选择 -->
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <!-- 住址选择 -->
    <van-popup v-model="showAddress" position="bottom" :style="{ height: '40%' }">
      <van-area
        :area-list="areaList"
        :value="areaCode"
        @confirm="sure"
        @cancel="exit"
      />
    </van-popup>
  </div>
</template>
<script>

import Vue from 'vue';
import addressList from '../../../public/addressList/area'
import { ActionSheet, Area, Popup} from 'vant';
import qs from 'qs';

Vue.use(ActionSheet);
Vue.use(Area);
Vue.use(Popup);

export default {
  data(){
    return{
      show: false,
      // 选择性别组件
      actions: [
        { name: '男' , code: '1'},
        { name: '女' , code: '2' },
      ],
      sex:'', // 性别

      userlist: [], // 现住址
      showAddress: false, // 先住址弹窗
      areaList: addressList, // 选中省市区
      areaCode:'', // 选中省市区的code 
      realname: '', // 真实姓名
      addressMsg: '', // 详细地址
      job: '', //行业背景
      card_no : '', // 身份证号
      
    }
  },
  created(){
    // 登录
    let url = this.$route.path
    let userId = JSON.parse(localStorage.getItem("uid"));
    // console.log(this.url)
    if(!this.userId){
      this.$axios.get("http://members.kfm666666.net/api/user/public/login?url="+this.url).then((res) => {
          // console.log(res)
          let uid = res.data.data.uid
          // console.log(uid)
          if(res.data.code == 1){
            window.localStorage.setItem('uid',JSON.stringify(uid));
          }
      })
    }
  },
  methods:{
    // 性别组件
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.sex = item.code
    },
    // 性别选择
    sexSelect(){
      this.show = true
    },
    // 收货地址
    showAddressChuang(){
      this.showAddress = true
    },
    // 选择地址完成按钮
    sure(val){
      this.showAddress = false
      console.log(val)
      this.userlist.address = val[0].name + "/"+val[1].name+"/"+val[2].name;
      console.log(this.userlist)
    },
    // 选择地址取消按钮
    exit(){
      this.showAddress = false
    },
    // 提交信息
    submitBtn(){
      // let usrId=JSON.parse(localStorage.getItem("uid"));
      let parms = {
        sex : this.sex,
        realname : this.realname,
        city : this.userlist.address,
        address : this.addressMsg,
        job : this.job,
        card_no : this.card_no,
        // address_number : 
      }
      console.log(parms)
      this.$axios.post('/api/user/public/edituserinfo',qs.stringify(parms)).then((res) => {
        console.log(res)
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .Perfect{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #E4E4E4 solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      flex: 1;
      overflow: scroll;
      // 填写个人信息
      .per-msg{
        width: 6.9rem;
        // height: 8rem;
        margin: 0 auto;
        box-shadow: 0rem 0.01rem 0.1rem 0rem rgba(0,0,0,0.22);
        margin-top: .2rem;
        margin-bottom: .48rem;
        overflow: hidden;
        padding-bottom: .3rem;
        // 标题
        .title{
          width: 100%;
          text-align: center;
          font-family: PingFang-SC-Medium;
          color: #EF8201;
          font-size: 0.3rem;
          line-height: .3rem;
          margin-top: .42rem;
          margin-bottom: .43rem;
        }
        .code{
          p{
            :first-child{
              display: flex;
              align-items: center;
              margin-left: .25rem;
              input{
                font-size: .24rem;
              }
            }

          }
        }
        div{
          width: 6.32rem;
          height: 0.88rem;
          border: .01rem #E4E4E4 solid;
          margin: 0 auto;
          margin-top: .2rem;
          border-radius: .1rem;
          // display: flex;
          p{
            color: #999999;
            font-family: PingFang-SC-Medium;
            &:nth-child(1){
              float: left;
              margin-left: .25rem;
              font-size: 0.3rem;
              line-height: .88rem;
            }
            &:last-child{
              height: .88rem;
              display: flex;
              align-items: center;
              float: right;
              font-size: 0.24rem;
              margin-right: .22rem;
              input{
                text-align: right;
                border: none;
                outline: none;
                color: #999999;
              }
            }
          }
        }
        // 银行卡标题
        .title-tow{
          width: 100%;
          text-align: center;
          font-family: PingFang-SC-Medium;
          color: #EF8201;
          font-size: 0.3rem;
          line-height: .3rem;
          margin-top: .35rem;
          margin-bottom: .29rem;
        }
      }
      // 提交按钮
      .sub-btn{
        width: 4.8rem;
        height: .88rem;
        text-align: center;
        line-height: .88rem;
        background: #EF8201;
        font-family: PingFang-SC-Bold;
        font-weight: Bold;
        color: #ffffff;
        font-size: 0.36rem;
        margin: 0 auto;
        margin-bottom: .46rem;
      }
    }
  }
</style>